'use strict';

import { PopUp } from '../../interfaces/pages/PopUp';
import { BaseElement } from '../../interfaces/BaseElement';

export class Preview {
	
	constructor (url) {
		this.popUp = new PopUp({
			id: 'preview',
			destroy: true
		});
		
		new BaseElement('iframe')
			.addClass('preview__iframe')
			.addAttribute('src','https://docs.google.com/viewer?url=' + window.location.origin + url + '&embedded=true' )
			.appendTo(this.popUp.content)
			.DOMElement;
		
		this.popUp.show();
	}
}
